import { createTextMaskInputElement } from 'text-mask-core'
import { useLayoutEffect, useRef } from 'react'

export default function useMaskedInput({
  guide,
  input,
  keepCharPositions,
  mask,
  onChange,
  pipe,
  placeholderChar,
  showMask,
  value = '',
  name,
}) {
  let textMask = useRef()

  function init() {
    if (!input.current) return

    textMask.current = createTextMaskInputElement({
      guide,
      inputElement: input.current,
      keepCharPositions,
      mask,
      pipe,
      placeholderChar,
      showMask,
    })

    textMask.current.update(value)
  }

  useLayoutEffect(init, [
    guide,
    keepCharPositions,
    mask,
    pipe,
    placeholderChar,
    showMask,
  ])

  useLayoutEffect(() => {
    if (value === input.current.value) return

    init()
  }, [value])

  return event => {
    if (textMask.current) {
      let valueBefore = input.current.value
      let caretStartPositionBefore = input.current.selectionStart

      textMask.current.update()

      let valueAfter = input.current.value
      let caretStartPositionAfter = input.current.selectionStart

      if (name === 'currency') {
        // Detect the character typed
        let characterTyped = event.nativeEvent.data

        if (characterTyped === '0') {
          // Check if the caret moved backward or did not move
          let caretMovedBackwardOrDidNotMove =
            caretStartPositionAfter <= caretStartPositionBefore
          let decimalIndex = valueAfter.indexOf('.')
          let isAfterDecimal =
            caretStartPositionBefore > decimalIndex && decimalIndex !== -1

          if (
            caretMovedBackwardOrDidNotMove &&
            isAfterDecimal &&
            valueBefore !== valueAfter
          ) {
            input.current.setSelectionRange(
              caretStartPositionBefore,
              caretStartPositionBefore
            )
          }
        }
      }
    }

    if (typeof onChange === 'function') {
      onChange(event)
    }
  }
}
